let language = {
    GOOGLE_LOGIN_BTN_TEXT: "Google",
};

export { language }